export const orderStates = {
  all: 'All',
  accepted: 'Unassigned',
  assigned: 'Assigned',
  'in progress': 'In Progress',
  complete: 'Completed',
}
